import React from 'react'
import { Container, Card, CardColumns, Row, Col } from 'react-bootstrap';
import {
	FaSync, FaSearchDollar, FaFileImport,
	FaUsersCog, FaMailBulk, FaShareSquare, FaEye
} from "react-icons/fa";
import { MdWeb } from "react-icons/md";

import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'

const Sobre = (props) => {
	const { id } = props;

	const getImagenes = graphql`
	{
		funciones:file(relativePath: {eq: "funciones.jpg"}) {
			childImageSharp {
				fluid{
					...GatsbyImageSharpFluid
				}
			}
		}

	}`
	const data = useStaticQuery(getImagenes);
	const { funciones } = data;

	return (

		<section className="page-section" >
			<div className="name-section" id={id}>
				<Container >
					<h2 className="text-center mt-0 title-general">¿Qué es Monitor?</h2>
					<hr className="divider my-4" />
					<Row className="mb-5">
						<Col md={{ span: 8, offset: 2 }}>
							<p className="text-center">
								Es una plataforma web que recupera de forma automática desde el Servicio de Impuestos Internos
								(SII) todos los eventos vinculados a los documentos que el factoring ha recibido en calidad de
								cesionario, centralizando información vital para análisis de riesgo y financiamiento en un solo lugar.
							</p>
						</Col>
					</Row>
					<Row className="mb-5">
						<Col md={7}>
							<h2 className="mt-0 title-general">Funciones</h2>
							<hr className="divider-2 my-4" />
							<Row>
								<Col xs={1}><FaSync color="#0680ff" /></Col>
								<Col xs={11}>
									Sincroniza automáticamente tu cuenta con el registro nacional de cesión de créditos y visualiza AEC’s y PDF’s de los documentos que te han cedido.
								</Col>
							</Row>
							<br />
							<Row>
								<Col xs={1}><FaFileImport color="#0680ff" /></Col>
								<Col xs={11}>
									Recupera Certificados de Cesión y Certificados de Aceptación o Reclamo de todos los documentos.
								</Col>
							</Row>
							<br />
							<Row>
								<Col xs={1}><FaSearchDollar color="#0680ff" /></Col>
								<Col xs={11}>
									Monitorea cuando los documentos son aceptados o rechazados por los receptores.
								</Col>
							</Row>
							<br />
							<Row>
								<Col xs={1}><FaEye color="#0680ff" /></Col>
								<Col xs={11}>
									Verifica si los documentos cuentan con anulación o rebaja por notas de crédito.
								</Col>
							</Row>
							<br />
							<Row>
								<Col xs={1}><FaShareSquare color="#0680ff" /></Col>
								<Col xs={11}>
									Re-cede directamente desde la plataforma para devolver documentos o enviarlos a la bolsa.
								</Col>
							</Row>
						</Col>
						<Col md={5} className="px-5 mt-5">
							<br /><br />
							<Image fluid={funciones.childImageSharp.fluid} />
						</Col>
					</Row>


					<h2 className="text-center mt-3 title-general">Otras características</h2>
					<hr className="divider my-4" />

					<CardColumns className="text-center">
						<Card>
							<Card.Body>
								<Card.Title className="text-center"><FaUsersCog color="#0680ff" size={32} /></Card.Title>
								<Card.Text>
									Multi-usuario con permisos personalizables
							</Card.Text>
							</Card.Body>
						</Card>

						<Card>
							<Card.Body>
								<Card.Title className="text-center"><FaMailBulk color="#0680ff" size={32} /></Card.Title>
								<Card.Text>
									Notificación personalizada de eventos <br />a e-mail
							</Card.Text>
							</Card.Body>
						</Card>

						<Card>
							<Card.Body>
								<Card.Title className="text-center"><MdWeb color="#0680ff" size={32} style={{ transform: 'scale(-1, 1)' }} /></Card.Title>
								<Card.Text>
									100% web con alternativas de <br />integración
							</Card.Text>
							</Card.Body>
						</Card>

					</CardColumns>




				</Container >
			</div>


		</section >
	)
}

export default Sobre
